module.exports = __webpack_public_path__ + "img/CMCSA.3a8805a4.png";